import { DatePicker } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * A component that renders a date picker using antd. It internally uses dayjs to represent dates.
 *
 * @param {Object} props
 * @param {string} props.value - The value of the selected date
 * @param {string} props.format - The format of the date. look up dayjs documentation to see the options
 * @param {string} props.name - The HTML name of the input
 * @param {(e: string)=>{}} props.onChange - A function that runs when the selected option changes
 * @param {(date)=>{}} props.disabledDate - A function that accepts a date and returns a boolean to indicate whether that date should be disabled or not
 * @returns {JSX.Element}
 */

const DatePickerInput = ({ value, format, onChange, name, disabledDate }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const cellRender = (current, info) => {
    const symbolMap = {
      1: "١",
      2: "٢",
      3: "٣",
      4: "٤",
      5: "٥",
      6: "٦",
      7: "٧",
      8: "٨",
      9: "٩",
      0: "٠",
    };
    if (info.type !== "date") {
      return info.originNode;
    }
    if (typeof current === "number" || typeof current === "string") {
      return (
        <div className="ant-picker-cell-inner">
          {language === "ar"
            ? current.replace(/\d/g, (match) => symbolMap[match])
            : current}
        </div>
      );
    }
    return (
      <div className="ant-picker-cell-inner">
        {language === "ar"
          ? current
              .date()
              .toString()
              .replace(/\d/g, (match) => symbolMap[match])
          : current.date()}
      </div>
    );
  };

  return (
    <DatePicker
      format={format}
      value={value}
      cellRender={cellRender}
      onChange={onChange}
      name={name}
      disabledDate={disabledDate}
    />
  );
};

export default DatePickerInput;
